import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.light};
`;

export const LinksContainer = styled.div`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.grey.hitGrey};
  font-size: 22px;
  background-color: ${({ theme }) => theme.colors.secondary};
`;

export const IconWrapper = styled.div`
  padding: 5px 15px;
  cursor: pointer;
  transition: all 320ms ease-in-out;
  &:first-of-type {
    padding-left: 18px;
  }
  &:last-of-type {
    padding-right: 18px;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
